import React, { Component } from "react";
import { toast } from "react-toastify";
import Paper from "@material-ui/core/Paper";
import DashboardBoxes from "../components/dashboardBoxes";
//import BarChart from "./common/barChart";
import { isAdmin, isCustomer } from "../services/authService";
import PageLoading from "../components/common/pageLoading";
import { getAdminDashboardData, getCustomerDashboardData } from "../services/dashboardService";
import { getMyDataUsage } from "../services/dataUsageService";

class Dashboard extends Component {
  state = {
    customerData: {},
    adminData: {},
    customerDataUsage: [],
    loading: "",
  };

  constructor() {
    super();
    this.state.loading = true;
  }

  async getCustomerData() {
    try {
      const { data } = await getCustomerDashboardData();
      this.setState({ customerData: data });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async getMyDataUsage() {
    try {
      const { data } = await getMyDataUsage();
      this.setState({ customerDataUsage: data });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async getAdminData() {
    try {
      const { data } = await getAdminDashboardData();
      this.setState({ adminData: data });
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async componentDidMount() {
    if (isCustomer()) {
      await this.getCustomerData();
      await this.getMyDataUsage();
    } else if (isAdmin()) {
      await this.getAdminData();
    }
  }

  render() {
    const { customerData, customerDataUsage, adminData, loading } = this.state;
    return (
      <React.Fragment>
        {loading && <PageLoading loading={loading} />}
        <Paper elevation={3}>
          {loading === false && isCustomer() && <DashboardBoxes customerData={customerData} />}
          {loading === false && isAdmin() && <DashboardBoxes adminData={adminData} />}
        </Paper>
        {/* <div className="row">
          {customerDataUsage.map((dataUsage) => (
            <div key={dataUsage._id} className="col-md">
              <Paper elevation={3} className="mt-5">
                {loading === false && isCustomer() && <BarChart dataUsage={dataUsage} />}
              </Paper>
            </div>
          ))}
        </div> */}
      </React.Fragment>
    );
  }
}

export default Dashboard;
